// import React from 'react';
// import { Link } from 'react-router-dom';
// import './Card.css';

// export default function Card({ blog, category }) {
//   return (
//     <div className="blog-card">
//       {blog.image && (
//         <img src={blog.image} alt={blog.title} className="blog-card-image" />
//       )}
//       <h3>{blog.title}</h3>
//       <p>{blog.summary}</p>
//       <Link to={`/blog/${category}/${blog.id}`} className="read-more">
//         Read More
//       </Link>
//     </div>
//   );
// }


import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Card.module.css';

export default function Card({ blog, category }) {
  return (
    <div className={styles.blogCard}>
      {blog.image && (
        <img src={blog.image} alt={blog.title} className={styles.blogCardImage} />
      )}
      <h3>{blog.title}</h3>
      <p>{blog.summary}</p>
      <Link to={`/blog/${category}/${blog.id}`} className={styles.readMore}>
        Read More
      </Link>
    </div>
  );
}
